import React, { useEffect, useState } from 'react';
import { Checkbox, Form, Input, Select, Space } from 'antd'
import PlusCircleOutlined from "@ant-design/icons/PlusCircleOutlined";
import MinusCircleOutlined from "@ant-design/icons/MinusCircleOutlined";
import './style.css'
import { message, Switch } from 'antd/lib';
import { postRequestApiByToken } from '../../../api';

const DeviceId = ({ formUser, getuserinfo }) => {
    const [ls_switchLoading, setSwitchLoading] = useState(null);
    const deviceIdDetails = Form.useWatch('device_id', formUser);

    // const onChangeStatus = async (checked, key, row) => {
    //     setSwitchLoading((key+1) || null);
    //     let lo_formData = { status: (checked == true ? 1 : 0), id: row.id }
    //     const res = await postRequestApiByToken('device_status_update', lo_formData)
    //     setSwitchLoading(null);
    //     if (res?.status == "Success") {
    //         getuserinfo();
    //         message.success(`${row?.status == 1 ? 'Incativated' : 'Activated'} Successfully!`);
    //     }
    // };

    const onChangeStatus = async (checked, fieldName, row) => {
        try {
            setSwitchLoading(fieldName); // Set loading state for the specific switch

            let lo_formData = {
                status: checked ? 1 : 0, // Set status based on the checked value
                id: row.id
            };

            const res = await postRequestApiByToken('device_status_update', lo_formData);

            setSwitchLoading(null); // Remove loading state

            if (res?.status === "Success") {
                getuserinfo(); // Refresh user info after update
                message.success(`${checked ? 'Activated' : 'Inactivated'} Successfully!`);
            } else {
                message.error("Failed to update status. Please try again.");
            }
        } catch (error) {
            console.error("Error updating device status:", error);
            message.error("An error occurred. Please try again.");
            setSwitchLoading(null);
        }
    };


    useEffect(() => {
        console.log('---deviceIdDetails--', deviceIdDetails);

    }, [deviceIdDetails])

    return (
        <div className='ipformitem-space'>

            <Form.Item noStyle >
                <Form.List name={['device_id']} >
                    {(fields, { add, remove }) => (
                        <>

                            {fields.map((field, index) => (
                                <div
                                    key={field.key}
                                    className='deviceformitem-list'
                                >
                                    <Form.Item
                                        style={{ marginBottom: 10, width: '24%', marginRight: 8 }}
                                        name={[field.name, 'type']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required!',
                                            },
                                        ]}
                                    >
                                        <Select disabled placeholder="Select" style={{ width: '100%', cursor: 'pointer' }} >
                                            <Select.Option value={'Desktop'} key={1}>Desktop</Select.Option>
                                            <Select.Option value={'Mobile'} key={2}>Mobile</Select.Option>
                                        </Select>
                                    </Form.Item>


                                    <Form.Item
                                        name={[field.name, 'manufacturer']}
                                        style={{ marginBottom: 10, width: '38%', marginRight: 8 }}

                                    >
                                        <Input readOnly></Input>
                                    </Form.Item>

                                    <Form.Item
                                        name={[field.name, 'model']}
                                        style={{ marginBottom: 10, width: '38%', marginRight: 8 }}
                                    >
                                        <Input readOnly></Input>
                                    </Form.Item>

                                    {
                                        <>
                                            <MinusCircleOutlined style={{ color: "red" }}
                                                // onClick={() => remove(index)} 
                                                onClick={() => remove(field.name)}
                                            />
                                            &nbsp;
                                            {/* {(deviceIdDetails && deviceIdDetails[field?.key] && deviceIdDetails[field?.key]?.id) ?
                                                <Switch loading={ls_switchLoading == field?.key+1} defaultChecked={(deviceIdDetails && deviceIdDetails[field?.key] && deviceIdDetails[field?.key]?.status)} size='small' 
                                            onChange={(s) => onChangeStatus(s, field?.key, deviceIdDetails[field?.key])} 
                                            />
                                            :
                                            <div style={{width: 30}}></div>
                                            } */}

                                            {(deviceIdDetails && deviceIdDetails[field?.name] && deviceIdDetails[field?.name]?.id) ? (
                                                <Switch
                                                    loading={ls_switchLoading === field.name}
                                                    defaultChecked={deviceIdDetails[field?.name]?.status}
                                                    size='small'
                                                    onChange={(s) => onChangeStatus(s, field.name, deviceIdDetails[field.name])}
                                                />
                                            ) : <div style={{ width: 30 }}></div>}

                                        </>
                                    }

                                </div>
                            ))}
                        </>
                    )}
                </Form.List>
            </Form.Item>
        </div>
    )
}

export default DeviceId